import GLOBALS from '../utils/Constants';
import UserService from './users-service';

class AssignmentService{
  	static sharedInstance = AssignmentService.sharedInstance ? this.sharedInstance : new AssignmentService();

    constructor(){
    	//initialize
	    this.credentials = UserService.sharedInstance.getStoredCredentials();
	    this.auth_username = this.credentials.username;
	    this.license = this.credentials.license;
	    this.token = this.credentials.token;
	    this.user_id = this.credentials.recno;
    }

    getUpdatedCrendetials(){
    	this.credentials = UserService.sharedInstance.getStoredCredentials();
	    this.auth_username = this.credentials.username;
	    this.license = this.credentials.license;
	    this.token = this.credentials.token;
	    this.user_id = this.credentials.recno;
    }

    async setOnDutyStatus(onDuty){

    	this.getUpdatedCrendetials();

	  	const params = {
	        "license": this.license,
	        "auth_username": this.auth_username,
	        "token":  this.token,
	        "id": this.user_id,
	        "on_duty": onDuty ? 1 : 0
	    }


	    const formBody = UserService.sharedInstance.urlEncodeParams(params);
	    const response = await fetch(GLOBALS.SET_ON_DUTY_STATUS, {
	        method: 'PUT',
	        headers: {
	            'Content-Type':'application/x-www-form-urlencoded'
	        },
	        body: formBody
	    });

	    const responseJson = await response.json();
	    try {
	        UserService.sharedInstance.checkIfTokenIsValid(responseJson);
	        return responseJson;
	    } catch (error) {
	        console.error("setOnDutyStatus Error:", error);
	    }
	}

	async getAllByLicense(){

    	this.getUpdatedCrendetials();

	  	const params = {
	        "license": this.license,
	        "auth_username": this.auth_username,
	        "token":  this.token
	    }

	    const formBody = UserService.sharedInstance.urlEncodeParams(params);
	    const response = await fetch(GLOBALS.GET_ALL_BY_LICENSE_API+"&"+formBody, {
	        method: 'GET',
	        headers: {
	            'Content-Type':'application/x-www-form-urlencoded'
	        }
	    });

	    const responseJson = await response.json();
	    try {
	        UserService.sharedInstance.checkIfTokenIsValid(responseJson);
	        return responseJson;
	    } catch (error) {
	        console.error("setOnDutyStatus Error:", error);
	    }
	}

	async getAllByPersonnelId(){

    	this.getUpdatedCrendetials();

	  	const params = {
	        "license": this.license,
	        "auth_username": this.auth_username,
	        "token":  this.token,
	        "personnel_id": this.credentials.recno
	    }
	    const formBody = UserService.sharedInstance.urlEncodeParams(params);
	    const response = await fetch(GLOBALS.GET_ALL_BY_PERSONNEL_ID_API+"&"+formBody, {
	        method: 'GET',
	        headers: {
	            'Content-Type':'application/x-www-form-urlencoded'
	        }
	    });

	    const responseJson = await response.json();
	    try {
	        UserService.sharedInstance.checkIfTokenIsValid(responseJson);
	        return responseJson;
	    } catch (error) {
	        console.error("setOnDutyStatus Error:", error);
	    }
	}

	async updateDispatchStatus(params){

    	this.getUpdatedCrendetials();

	  	const finalParams = {
	        "license": this.license,
	        "auth_username": this.auth_username,
	        "token":  this.token,
	        "dispatch_id": params.dispatch_id,
	        "status":params.status
	    }
	    const formBody = UserService.sharedInstance.urlEncodeParams(finalParams);
	    const response = await fetch(GLOBALS.UPDATED_DISPATCH_STATUS_API, {
	        method: 'PUT',
	        headers: {
	            'Content-Type':'application/x-www-form-urlencoded'
	        },
	        body: formBody
	    });

	    const responseJson = await response.json();
	    try {
	        UserService.sharedInstance.checkIfTokenIsValid(responseJson);
	        return responseJson;
	    } catch (error) {
	        console.error("setOnDutyStatus Error:", error);
	    }
	}
}

export default AssignmentService;